export default {"src":"/_next/static/media/high-five.mono.b62c4f70.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};